import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Icon } from 'semantic-ui-react';

import useWindowDimensions from '../../../../../../../shared/custom-hooks/useWindowDimension';
import Loading from './loading';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const PDFViewer = ({ showPaginationOnMobile = false, src }) => {
  const { width } = useWindowDimensions();
  const [error, setError] = useState(false);
  const [numPages, setNumPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [isHovered, setIsHovered] = useState(false);

  function handleLoad() {
    setLoading(false);
  }

  function handleError(err) {
    setError(true);
    setLoading(false);
    console.error(err ? err : 'Failed to load the video.');
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function onPageLoadSuccess() {
    handleLoad();
  }

  function goToNextPage() {
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  }

  function goToPreviousPage() {
    setPageNumber((prevPageNumber) => prevPageNumber - 1);
  }

  useEffect(() => {
    setLoading(true);
    setPageNumber(1);
  }, [src]);

  useEffect(() => {
    if (showPaginationOnMobile && width <= 912 && !isHovered) {
      setIsHovered(true);
    }
  }, [width]);

  return (
    <>
      {loading && <Loading />}
      {error ? (
        <div style={{ color: 'white' }}>Error: Failed to load the document.</div>
      ) : (
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ height: '100%', position: 'relative', display: loading ? 'none' : 'block' }}>
          <Document
            file={src}
            className="pdf-doc"
            data-testid="preview-doc"
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(err) => handleError(err)}>
            <Page
              className="pdf-page"
              pageNumber={pageNumber}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              onLoadSuccess={onPageLoadSuccess}
            />
          </Document>
          {isHovered && (
            <div className="pdf-pagination">
              <button onClick={goToPreviousPage} disabled={pageNumber === 1}>
                <Icon size="small" name="chevron left" />
              </button>
              <p>
                {pageNumber} of {numPages}
              </p>
              <button onClick={goToNextPage} disabled={pageNumber === numPages}>
                <Icon size="small" name="chevron right" />
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PDFViewer;
